import { Image, StyleSheet, View } from 'react-native';
import type { StyleProp, ViewStyle } from 'react-native';

type BrandLogoVariant = 'full' | 'icon';
type BrandLogoSize = 'sm' | 'md' | 'lg';

type BrandLogoProps = {
  variant?: BrandLogoVariant;
  size?: BrandLogoSize;
  centered?: boolean;
  style?: StyleProp<ViewStyle>;
};

const logoImage = require('../../assets/branding/frienzzi-logo.png');
const iconImage = require('../../assets/branding/frienzzi-icon.png');

export function BrandLogo({
  variant = 'full',
  size = 'md',
  centered = false,
  style,
}: BrandLogoProps) {
  const imageStyle = variant === 'icon' ? iconSizes[size] : logoSizes[size];

  return (
    <View style={[centered ? styles.centered : null, style]}>
      <Image
        accessibilityLabel="frienzzi"
        resizeMode="contain"
        source={variant === 'icon' ? iconImage : logoImage}
        style={imageStyle}
      />
    </View>
  );
}

const logoSizes = StyleSheet.create({
  sm: {
    height: 42,
    width: 132,
  },
  md: {
    height: 58,
    width: 182,
  },
  lg: {
    height: 78,
    width: 242,
  },
});

const iconSizes = StyleSheet.create({
  sm: {
    height: 40,
    width: 40,
  },
  md: {
    height: 56,
    width: 56,
  },
  lg: {
    height: 72,
    width: 72,
  },
});

const styles = StyleSheet.create({
  centered: {
    alignItems: 'center',
  },
});
